import { render, staticRenderFns } from "./CustomFormCompGroup.vue?vue&type=template&id=5f2a2cc5"
import script from "./CustomFormCompGroup.vue?vue&type=script&lang=js"
export * from "./CustomFormCompGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports